/**
 * Wrap a promise so it rejects with a helpful error if it doesn't settle in time.
 * Useful for Supabase RPC / network calls that can occasionally hang silently
 * and would otherwise leave UI in a perpetual "loading" state.
 */
export async function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number = 15_000,
  label: string = 'Request',
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      reject(new Error(`${label} timed out after ${Math.round(ms / 1000)}s. Please try again.`))
    }, ms)
  })
  try {
    return (await Promise.race([promise, timeout])) as T
  } finally {
    if (timer) clearTimeout(timer)
  }
}
